<template>
    <div style="min-height: 66vh;">
        <botao-nova-reavaliacao
            :exibirLinhaDoTempo="exibirLinhaDoTempo"
            :exibirTooltipReavaliacao="exibirTooltipReavaliacao"
            @abrirModalNovaReavaliacao="tratarEventoAbrirModalNovaReavaliacao"
        />
        <div v-if="exibirLinhaDoTempo">
            <linha-do-tempo-reavaliacao
                :items="items"
                :orgaos="orgaos"
                @abrirModalMaisDetalhes="redirecionaParaModalDetalhes"
                @acessarVisualizacao="acessarVisualizacao"
            />
        </div>
        <router-view
            @fecharModalReavaliacao="fecharModalReavaliacao"
            @atualizarReavaliacao="tratarEventoAtualizarReavaliacao"
            @acessarVisualizacao="acessarVisualizacao"/>
    </div>
</template>

<script>
    import BotaoNovaReavaliacao from './BotaoNovaReavaliacao'
    import LinhaDoTempoReavaliacao from './LinhaDoTempoReavaliacao'
    import {actionTypes} from '@/core/constants'
    import {mapActions} from 'vuex'

    export default {
        name: 'NovaReavaliacao',
        components: {BotaoNovaReavaliacao, LinhaDoTempoReavaliacao},
        data() {
            return {
                reavaliacao: {},
                patrimonioId: null,
                orgaos: [],
                items: [],
                tipo: null,
                situacao: null,
                estaInserindo: false,
                exibirLinhaDoTempo: false,
                exibirTooltipReavaliacao: false
            }
        },
        async mounted() {
            this.setarIdPatrimonio()
            await this.buscarPatrimonio()
            await this.buscarReavaliacoes()
        },
        methods: {
            ...mapActions([
                actionTypes.PATRIMONIO.VISUALIZAR_PATRIMONIO_POR_ID,
                actionTypes.REAVALIACAO.BUSCAR_REAVALIACAO_POR_PATRIMONIO,
                actionTypes.COMUM.BUSCAR_TODOS_ORGAOS
            ]),
            setarIdPatrimonio() {
                this.patrimonioId = this.$route.params.id
            },
            async buscarPatrimonio() {
                await this.visualizarPatrimonioPorId(this.patrimonioId)
            },
            async tratarEventoAtualizarReavaliacao(reavaliacao) {
                this.estaInserindo = false
                this.reavaliacao = await this.atualizarReavaliacao(reavaliacao)
            },
            async buscarReavaliacoes() {
                if (!this.estaInserindo) {
                    const resultado = await this.buscarReavaliacaoPorPatrimonio({idPatrimonio: this.$route.params.id})
                    this.items = resultado.items
                    this.deveExibirLinhaDoTempo()
                    this.deveExibirTooltipReavaliacao()
                } else {
                    this.estaInserindo = false
                }
            },
            deveExibirLinhaDoTempo() {
                this.exibirLinhaDoTempo = this.items.length !== 0
            },
            deveExibirTooltipReavaliacao() {
                if (this.exibirLinhaDoTempo) {
                    let ehReavaliacaoEmElaboracao = this.items.filter((item) => {
                        return item.situacao !== 'FINALIZADO' && item.situacao !== 'REJEITADO'
                    })
                    this.exibirTooltipReavaliacao = ehReavaliacaoEmElaboracao.length !== 0
                }
            },
            async fecharModalReavaliacao() {
                await this.$router.push({
                    name: 'NovaReavaliacao',
                    params: {id: this.patrimonioId}
                })
                await this.buscarReavaliacoes()
            },
            async tratarEventoAbrirModalNovaReavaliacao() {
                await this.$router.push({
                    name: 'ModalReavaliacao',
                    params: {id: this.patrimonioId}
                })
            },
            async redirecionaParaModalDetalhes(reavaliacao) {
                await this.$router.push({
                    name: 'ModalReavaliacaoDetalhes',
                    params: {reavaliacaoId: reavaliacao.id}
                })
            },
            async acessarVisualizacao(reavaliacao) {
                await this.$router.push({
                    name: 'ReavaliacaoDetalhe',
                    params: {reavaliacaoId: reavaliacao.id},
                    query: {rotaOrigem: 'NovaReavaliacao'}
                })
            }
        }
    }
</script>
